var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialSymbolsCheckBoxRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 22.3333L14.0833 18.75C13.7778 18.4444 13.3889 18.2917 12.9167 18.2917C12.4444 18.2917 12.0556 18.4444 11.75 18.75C11.4444 19.0556 11.2917 19.4444 11.2917 19.9167C11.2917 20.3889 11.4444 20.7778 11.75 21.0833L16.5 25.8333C16.8333 26.1667 17.2222 26.3333 17.6667 26.3333C18.1111 26.3333 18.5 26.1667 18.8333 25.8333L28.25 16.4167C28.5556 16.1111 28.7083 15.7222 28.7083 15.25C28.7083 14.7778 28.5556 14.3889 28.25 14.0833C27.9444 13.7778 27.5556 13.625 27.0833 13.625C26.6111 13.625 26.2222 13.7778 25.9167 14.0833L17.6667 22.3333ZM8.33333 35C7.41667 35 6.63222 34.6739 5.98 34.0217C5.32778 33.3694 5.00111 32.5844 5 31.6667V8.33333C5 7.41667 5.32667 6.63222 5.98 5.98C6.63333 5.32778 7.41778 5.00111 8.33333 5H31.6667C32.5833 5 33.3683 5.32667 34.0217 5.98C34.675 6.63333 35.0011 7.41778 35 8.33333V31.6667C35 32.5833 34.6739 33.3683 34.0217 34.0217C33.3694 34.675 32.5844 35.0011 31.6667 35H8.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsCheckBoxRounded);
export default __webpack_public_path__ + "static/media/material-symbols_check-box-rounded.1c809449e46efb0b90ad80df18fbcdb0.svg";
export { ForwardRef as ReactComponent };